import * as Sentry from "@sentry/vue";
import { mapGetters } from "vuex";
export default {
  methods: {
    sendNotifications(notificationType, programId) {
      if (this.getCurrentStudentApplication?.bulkEnrollmentId) {
        return;
      }
      let isFirstSubmition = this.$route.path.indexOf("/submission/") === -1;
      if (notificationType && isFirstSubmition) {
        let postData = {
          event: notificationType,
          program_session_id: programId,
        };

        fetch(
          this.trailingSlash(import.meta.env.VITE_ENROLLMENT_SERVICE_ENDPOINT) +
            "advisor/notification",
          {
            method: "post",
            body: JSON.stringify(postData),
            headers: {
              "Content-type": "application/json",
              "x-jwt-token": this.getStudentToken,
            },
            mode: "cors",
          }
        ).catch((error) => {
          console.warn(error);
          Sentry.captureException(error, {
            tags: {
              troubleshooting_note: "Advisor Notification",
            },
          });
        });
      }
    },
  },
  computed: {
    ...mapGetters(["getCurrentStudentApplication", "getStudentToken"]),
  },
};
